// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth"; // ✅ ADD THIS
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBFXi62Rxxb2ggUitkLO4E9-MpoOxVpV9E",
  authDomain: "shaart-6d6b1.firebaseapp.com",
  projectId: "shaart-6d6b1",
  storageBucket: "shaart-6d6b1.firebasestorage.app",
  messagingSenderId: "205726577487",
  appId: "1:205726577487:web:c4ba557e52871d19420b3a",
  measurementId: "G-3C1HZJ7LY8"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and export it
export const auth = getAuth(app); // ✅ ADD THIS

// Initialize Analytics (optional)
export const analytics = getAnalytics(app);

export default app;